
import u from "umbrellajs"

import ContactInfo from "./components/contact_info/index"
import ContactInfoPrefilling from "./components/contact_info_prefilling/index"
import SendSpaciousEnquiryButton from "./components/send_spacious_enquiry_button/index"
import RemoteSubmitForm from "./components/remote_submit_form/index"
import ShowPhoneNumberButton from "./components/show_phone_number_button/index"

const CELL_CLASS_NAME = "cell-new-development-contact-request-box"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }

    ContactInfo.init({scope: el})
    ContactInfoPrefilling.init({scope: el})
    SendSpaciousEnquiryButton.init({scope: el})
    ShowPhoneNumberButton.init({scope: el})
    RemoteSubmitForm.init({scope: el})

    el.classList.add(CELL_INITIALIZED_CLASS_NAME)
  })
}

export default {
  init,
}
